export default {
  name: 'Reign of Money…. what the f$ck',
  title: 'Reign of Money…. what the f$ck',
  type: 'object',
  description:
    "The fact that this is based on a true story makes this painting even more crazy than it is.\nTo me it shows Belfort opening his arms to welcome you to the circus of bullshit, and yet\nyou look in his face, and it's kind of comforting.\nScary….\n\nRich feeding on the richer…. Cool.\n\nSo to me, with this painting and with the animation means:\n\nLet the money rain….\nSoak it up now….\nBecause eventually…\nThere is going to be a drought.\n\nso f$ck it:)",
  image: 'ipfs://QmSHCixTLC9u4uMELs4vcpzBmj3P7MCwZxWoU2qakdeA85',
  external_url:
    'https://v1.mglnft.com/0xEd9e2b88FEB7A94A682E7E3a59631E15E8442711/0',
  animation_url: 'ipfs://QmRM9nakQZbeEMUP7kKmmsVvRcE98u91WJziSpwkNZ1iJM',
  properties: {
    name: {
      type: 'string',
      description: 'Reign of Money…. what the f$ck',
    },
    description: {
      type: 'string',
      description:
        "The fact that this is based on a true story makes this painting even more crazy than it is.\nTo me it shows Belfort opening his arms to welcome you to the circus of bullshit, and yet\nyou look in his face, and it's kind of comforting.\nScary….\n\nRich feeding on the richer…. Cool.\n\nSo to me, with this painting and with the animation means:\n\nLet the money rain….\nSoak it up now….\nBecause eventually…\nThere is going to be a drought.\n\nso f$ck it:)",
    },
    external_url: {
      type: 'string',
      description:
        'https://v1.mglnft.com/0xEd9e2b88FEB7A94A682E7E3a59631E15E8442711/0',
    },
    animation_url: {
      type: 'string',
      description: 'ipfs://QmRM9nakQZbeEMUP7kKmmsVvRcE98u91WJziSpwkNZ1iJM',
    },
    author: {
      type: 'string',
      description: 'Rob Prior',
    },
    total_supply: {
      type: 'int',
      description: 1,
    },
    issue_date: {
      type: 'int',
      description: 1622038460,
    },
  },
  attributes: [
    {
      trait_type: 'Author',
      value: 'Rob Prior',
    },
    {
      display_type: 'date',
      trait_type: 'Issue Date',
      value: 1622038460,
    },
  ],
  painting_video: 'ipfs://QmZTGyRY1GtRkwstMAeqnz9WTfKciD3VkpFyDw5rqfNf3G',
  original_painting: 'ipfs://QmQVmaHwjuUVbunwoTvo9uKzCXgw4PWXZnVCMmaQVtwGKX',
};
